<template>
    <div
        class="next-departure"
        :class="[
            {
                canceled: departure.annule,
                imminent: departure.departMinutes < 1,
                'is-empty': !departure.departMinutes && departure.departMinutes != 0,
            },
        ]"
    >
        <div :class="{ 'is-canceled': departure.annule }">
            <div v-if="departure.annule" class="cancel-message">
                {{ t('canceled_departure') }}
            </div>
            <div v-if="departure.departMinutes < 1" class="pulse station-item">
                <IconBus class="imminent-bus" width="24px" height="24px" />
                <IconRealTime v-if="departure.ntr" class="realtime-icon" width="10px" height="10px" />
                <span class="visuallyhidden">{{ t('upcoming_departure') }}</span>
            </div>
            <div v-if="departure.departMinutes >= 1 && departure.departMinutes < 60" class="station-item">
                {{ departure.departMinutes }}
                <IconRealTime v-if="departure.ntr" class="realtime-icon" width="11px" height="9px" />
                <span class="minutes">min</span>
            </div>
            <div v-if="departure.departMinutes >= 60" class="station-item">
                {{ format(departure.depart, 'H:mm') }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n';

import { format } from '@@/js/utils/dateFns';
import IconRealTime from '@@/icons/realtime.svg';
import IconBus from '@@/icons/menu/bus.svg';

defineProps({
    departure: {
        type: Object,
        default: () => ({}),
    },
});

const { t } = useI18n({
    messages: {
        fr: {
            canceled_departure: 'Passage annulé',
            upcoming_departure: 'Départ sous peu',
        },
        en: {
            canceled_departure: 'Cancelled departure',
            upcoming_departure: 'Upcoming departure',
        },
    },
});
</script>

<style lang="scss" scoped>
.next-departure {
    @include rem-typo(22px);
    position: relative;
    &.is-empty {
        height: 0;
    }
    &.imminent {
        text-align: center;
        .realtime-icon {
            top: 1px;
        }
        .station-item {
            text-align: left;
        }
    }
    .cancel-message {
        @include rem-typo(12px);
        position: absolute;
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
    }
    &.canceled {
        color: $color-black-10;
        .station-item {
            &::before {
                content: '';
                position: absolute;
                bottom: 25%;
                left: 50%;
                width: 55px;
                opacity: 1;
                border-top: 1px solid $color-white;
                transform: rotate(18deg) translatex(-50%);
            }
        }
    }
    .minutes {
        @include rem-typo(10px);
        margin-left: -3px;
    }
    .realtime-icon {
        position: absolute;
        top: 3px;
        margin-left: -3px;
        .widget-container & {
            top: 0;
            width: 9px;
            height: 6px;
            @include breakpoint(medium) {
                top: 3px;
                width: 11px;
                height: 9px;
            }
        }
    }
}
.is-canceled {
    .cancel-message {
        animation: flash 7s ease-out infinite;
    }
    .station-item {
        animation: flash-reverse 7s ease-out infinite;
    }
}
@keyframes flash {
    0% {
        opacity: 1;
    }
    20% {
        opacity: 1;
    }
    30% {
        opacity: 0;
    }
    70% {
        opacity: 0;
    }
    80% {
        opacity: 1;
    }
    100% {
        opacity: 1;
    }
}
@keyframes flash-reverse {
    0% {
        opacity: 0;
    }
    20% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    70% {
        opacity: 1;
    }
    80% {
        opacity: 0;
    }
    100% {
        opacity: 0;
    }
}
</style>
